import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api.service';
import { IpoAccOrderModalComponent } from '../ipo-acc-order-modal/ipo-acc-order-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Account } from 'src/app/screens/user-profile/client-data';
import { IPO, IPODetails, IpoDocuments } from 'src/app/models/IPO';
import { forkJoin } from 'rxjs';



@Component({
  selector: 'app-ipo-selected-symbol',
  templateUrl: './ipo-selected-symbol.component.html',
  styleUrls: ['./ipo-selected-symbol.component.scss'],
  
})
export class IpoSelectedSymbolComponent implements OnInit {

  lang: string;
  isDarkTheme: boolean;
  numberOfAccounts: number=2;
  @Input() id: number;
  @Input() ipoDocuments: IpoDocuments;
  @Input() refreshEvent: boolean = false;
  iPODetails: IPODetails;
  clinetsAccount: Account[];
  ipoList : IPO[] = null;
  lastSelectedIPOID:any;
  lastIpoList : IPO[] = null;
  IPOTotalVolume: any;
  selectedIPO: IPO;
  lastSelectedIpoIndex = -1;
  coverageNumber: string;
  coverageRatio: number;
  isRefreshing:boolean=false;
  DisabledEtrade: boolean;

  constructor(
    public translate: TranslateService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.lang = this.translate.currentLang;
    this.isDarkTheme =
      localStorage.getItem("darktheme") == "dark" ? true : false;
      this.GetAvailableIposList();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.refreshEvent && changes.refreshEvent.currentValue) {
      this.isRefreshing=true;
      this.GetIpoDetails(this.lastSelectedIPOID); 
    }
    this.id = changes.id?.currentValue;
    if(this.id){
      this.lastSelectedIPOID=this.id;
      this.GetIpoDetails(this.id);
    }
  }

  GetIpoDetails(id:number){
    this.apiService.GetIpoDetails(id)
    .subscribe(
      (res)=>{
        this.iPODetails = res;
        //this.GetAvailableIposList();
        this.checkDisabledEtradeStatus();
        this.ipoList.forEach((ipo)=>{
          this.handleCoverageCalculation(res.SymbolCode, this.iPODetails, ipo.ipoAllotmentRatio );})
        this.isRefreshing=false;
      }
    )
  }
  checkDisabledEtradeStatus(): void {
  
    if (this.ipoDocuments && Array.isArray(this.ipoDocuments.OprEvents)) {

      const hasDisabledEtrade = this.ipoDocuments.OprEvents.filter(
        event => event.DisabledEtrade === true || event.DisabledEtrade === 'true'
      );
   
      // If there are events with status 0 or 1, check DisabledEtrade for those events
      if (hasDisabledEtrade.length > 0) {

              // Check for events with status = 0 or 1
      const eventsWithStatus = this.ipoDocuments.OprEvents.filter(
        event => event.status != 0 &&  event.status != 1 // Corrected this line
      );
      if (eventsWithStatus.length<0) {
        
        this.DisabledEtrade = false
        
      }
      else{
        this.DisabledEtrade = true

      }
      } 
      else {


        this.DisabledEtrade = true

      }
    } 
  }

  fundActionModal() {
    this.dialog.open(IpoAccOrderModalComponent, {
      panelClass: "modal-width",
      data:{
        isBuy : true,
        numberOfAccounts: this.numberOfAccounts,
        IPO:  this.iPODetails
      }
    });
  }

  GetIpoDocuments(id){
    this.apiService.GetIpoDocuments(id)
    .subscribe(
      (res)=>{
        this.ipoDocuments = res;
      }
    )
  }



  GetAvailableIposList() {

    this.apiService.GetAvailableIposList()
    .subscribe(
      (res) => {
        if(res){
          this.ipoList = res;
          
          this.selectedIPO = this.ipoList[0];
          this.GetIpoDocuments(this.selectedIPO.Id);
          this.ipoList[0].selected = !this.ipoList[0].selected;
          this.GetIpoDetails(this.selectedIPO.Id)
          this.lastSelectedIpoIndex = 0; 
          const apiCalls = this.ipoList.map(ipo =>
            this.apiService.fetchIPOTotalVolume(ipo.SymbolCode)
          );
        
          forkJoin(apiCalls).subscribe((responses: number[]) => {
            this.ipoList = this.ipoList.map((ipo, index) => ({
              ...ipo,
              IPOTotalVolume: responses[index],
              ipoAllotmentRatio: ipo.PublicStake >= responses[index] 
                ? 100                   
                : (ipo.PublicStake / responses[index] ) * 100
            }));
          });
          
        } else {
          this.ipoList = null;
        }
      }
    );
  }


  async handleCoverageCalculation(symbolCode: string, ipoDetail: any ,ipoAllotmentRatio : any): Promise<void> {
    try {
      // Wait for the volume to be fetched
      const ipoTotalVolume = await this.fetchIPOTotalVolume(symbolCode);

  
      if (ipoTotalVolume) {
        // Pass the fetched volume to the coverage calculation
        this.CalculateIPOCoverage(ipoDetail, ipoTotalVolume , ipoAllotmentRatio);
        
      } else {
        this.isRefreshing=false;
      }
    } catch (error) {
      this.isRefreshing=false;
    }
  }



  fetchIPOTotalVolume(symbolCode: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService.fetchIPOTotalVolume(symbolCode).subscribe(
        (res) => {
          if (res) {
            if(this.ipoList==null)
                this.ipoList=this.lastIpoList;
            this.ipoList = this.ipoList.map((ipo) =>
              ipo.SymbolCode === symbolCode
                ? { ...ipo, IPOTotalVolume: res }
                : ipo
            );
            resolve(res); // Resolve with the volume response
          } else {
            this.coverageRatio=0;
            resolve(null); // Handle empty response
          }
        },
        (error) => {
          this.isRefreshing=false;
          reject(error); // Reject in case of error
        }
      );
    });
  }
  
  CalculateIPOCoverage(ipoDetail: any, ipoTotalVolume: number, ipoAllotmentRatio: any): number {
    
    // Ensure the ipoDetail and ipoTotalVolume are valid
    if (ipoDetail && ipoDetail.PublicStake && ipoTotalVolume) {
      const ipoAllocationRatio = 100 / ipoAllotmentRatio;
  
      // If the allocation ratio is 1 or more, return 0
      if (ipoAllocationRatio <= 1) {
        return   this.coverageRatio=0;
      } else {
        // If the allocation ratio is less than 1, return the calculated ratio
        return    this.coverageRatio= ipoAllocationRatio;
      }
    }
  
    // If the conditions are not met, return a default value (e.g., 0 or NaN)
    return 0;
  }
  
  

}
